import React from 'react';

import ethernet_down from './ethernet-down.svg';
import ethernet_unknown from './ethernet-unknown.svg';
import ethernet_up from './ethernet-up.svg';
import generic_down from './generic-down.svg';
import generic_unknown from './generic-unknown.svg';
import generic_up from './generic-up.svg';
import wifi_down from './wifi-down.svg';
import wifi_unknown from './wifi-unknown.svg';
import wifi_up from './wifi-up.svg';

type Props = {
  LinkType: string;
  LinkStatus: string;
};

const LinkStatusIndicator = ({ LinkType, LinkStatus }: Props) => {
  switch (LinkType.toLowerCase()) {
    case 'ethernet':
    case '802.3':
      switch (LinkStatus.toLowerCase()) {
        case 'up':
          return (
            <img
              width={16}
              src={ethernet_up}
              alt="Ethernet"
              title="Ethernet - Up"
            />
          );
        case 'down':
          return (
            <img
              width={16}
              src={ethernet_down}
              alt="Ethernet"
              title="Ethernet - Down"
            />
          );
        default:
          return <img width={16} src={ethernet_unknown} alt="Ethernet" />;
      }
    case 'wifi':
    case '802.11':
      switch (LinkStatus.toLowerCase()) {
        case 'up':
          return <img width={16} src={wifi_up} alt="Wifi" title="Wifi - Up" />;
        case 'down':
          return (
            <img width={16} src={wifi_down} alt="Wifi" title="Wifi - Down" />
          );
        default:
          return <img width={16} src={wifi_unknown} alt="Wifi" />;
      }
    default:
      switch (LinkStatus.toLowerCase()) {
        case 'up':
          return (
            <img
              width={16}
              src={generic_up}
              alt="Adapter"
              title="Adapter - Up"
            />
          );
        case 'down':
          return (
            <img
              width={16}
              src={generic_down}
              alt="Adapter"
              title="Adapter - Down"
            />
          );
        default:
          return <img width={16} src={generic_unknown} alt="Adapter" />;
      }
  }
};

export default LinkStatusIndicator;
